// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-title[data-v-11a53bac] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n.text[data-v-11a53bac] {\n    font-size: 18px;\n    font-weight: bold;\n    color: #303133;\n}\n}\n[data-v-11a53bac] .el-form-item__label {\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
